import script from "./introductionDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./introductionDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./introductionDetailPage.vue?vue&type=style&index=0&id=df1f87d4&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df1f87d4"]])

export default __exports__